<template>
  <div class="m-list-dashboard-assessments">
    <v-list v-if="!isEmpty(items)" three-line>
      <template v-for="(item, key, index) in chankOfItems">
        <m-card-object :key="key" :item="item" :hidden-actions="hiddenActions"/>
        <v-divider  :key="index" v-show="!isLastItem(index)"/>
      </template>
    </v-list>
    <div v-else class="pa-3">
      <e-typography-body-small>{{$t(`modules.lists.${name}.criterias.${criteria}.empty`)}}</e-typography-body-small>
    </div>
    <v-layout class="mb-0">
      <v-flex>
        <e-link-inline class="py-3 m-list-dashboard-assessments__more" v-if="isMore" @click="goToSearchPage">
          {{$t(`modules.lists.${name}.blocks.show_more`)}}
        </e-link-inline>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
    import MCardObject from "@modules/cards/concrete/m-card-object";
    const name = 'm-list-dashboard-assessments';
    import {DASHBOARD_LIST_LENGTH, SEARCH_FILTERS} from '@constants/common';
    import query from '@mixins/helpers/_query';

    export default {
        name,
        components: {MCardObject},
        inheritAttrs: false,
        props:{
            name: {
                type: String,
                default: name
            },
            items:{
                type: Object
            },
            searchPath: {
                type: String
            },
            criteria: {
                type: String
            },
            hiddenActions: {
                type: Array
            },
        },
        mixins: [query],
        computed: {
            isMore() {
                if (this.$lodash.isEmpty(this.items)) return false
                return Object.keys(this.items).length > DASHBOARD_LIST_LENGTH
            },
            chankOfItems() {
                if (this.$lodash.isEmpty(this.items)) return {}
                let res = {}
                Object.keys(this.items).slice(0, DASHBOARD_LIST_LENGTH).forEach( v => res[v] = this.items[v] )
                return  res
            }
        },
        methods:{
            isLastItem(index){
                return index === Object.keys(this.chankOfItems).length-1
            },
            isEmpty(val){
                return this.$lodash.isEmpty(val)
            },
            goToSearchPage() {
                let searchOptions = this.queryStringParamsToObject(this.searchPath);
                const orderOption = Object.keys(searchOptions).find(option => option.match(/order\[\w+\]/));

                let filters = SEARCH_FILTERS();

                Object.keys(searchOptions).map(optionKey => {
                    if(Object.keys(filters.riskAssessments).includes(optionKey)) {
                        filters.riskAssessments[optionKey] = this.stringToBool(searchOptions[optionKey])
                    }
                });
                let query = {
                    filters: this.prepareQueryString(filters)
                };
                if(orderOption) {
                    query.sortField = orderOption.substring(orderOption.indexOf('[')+1, orderOption.indexOf(']'));
                    query.sortOrder = searchOptions[orderOption];
                }

                this.redirect(this.nav.system.search.name, null, query, 'tab_risk_assessments');
            }
        }
    }
</script>

<style lang="scss" scoped>
  .m-list-dashboard-assessments {
    &__more {
      display: flex;
      justify-content: flex-end;
    }
  }
</style>
